import React, { useState } from "react";
import { Box, Button, Collapse, Stack, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { similarSeasonsGuideCopy } from "./similarSeasonsGuideCopy";

const SimilarSeasonsGuide = ({ league, role }) => {
  const [open, setOpen] = useState(false);
  const copy = similarSeasonsGuideCopy({ league, role });

  return (
    <Box sx={{ mb: 1 }}>
      <Button
        size="small"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        endIcon={
          <ExpandMoreIcon
            sx={{
              transform: open ? "rotate(180deg)" : "none",
              transition: "transform 0.2s ease",
            }}
          />
        }
        sx={{
          ml: -0.75,
          color: "text.secondary",
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        How to read this
      </Button>
      <Collapse in={open} unmountOnExit>
        <Stack spacing={0.75} sx={{ pt: 0.25, pb: 0.5 }}>
          {[copy.chips, copy.compare, copy.rates, copy.rank].map((sentence) => (
            <Typography
              key={sentence}
              variant="caption"
              color="text.secondary"
              display="block"
            >
              {sentence}
            </Typography>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
};

export default SimilarSeasonsGuide;
